import React from 'react';
import styled from 'styled-components';
import MoleculeTextareaDescription from '../../shared/component/molecule/MoleculeTextareaDescription';
import MemberProfileAndInfo from './MemberProfileAndInfo';
import { NormalSmallTextArea } from '../../shared/component/headless/textarea/TextAreaBody';
import { MEMBER_DESCRIPTION_MAX_LENGTH } from '../../shared/constants/limits';
import { AboutContentMode, DeviceType } from '../../shared/enum/EnumRepository';
import { getMemberDescriptionPlaceholder } from '../../shared/constants/pageMessages';
import { useAboutPage } from '../../shared/hooks/page/useAboutPage';
import orangeIcon from '../../asset/icon/orange.png';
import { imHere } from '../../shared/component/Animation';


const MemberInfo: React.FC = () => {
  const {
    canShowMember: canShow,
    memberInfo,
    isEditMode,
    hasChanged,
    imageChanged,
    handleChange,
    aboutContentMode,
    deviceType,
  } = useAboutPage();
  const isMobile = deviceType === DeviceType.MOBILE;

  if (!canShow || !memberInfo) {
    return null;
  }

  const showDescriptionBlock =
    isEditMode ||
    (aboutContentMode === AboutContentMode.ENG
      ? !!(memberInfo.descriptionEn ?? '').trim()
      : !!memberInfo.description);

  return (
    <MemberInfoComp
      data-has-changed={hasChanged || imageChanged ? "true" : "false"}    // 편집 모드 진입 시 변경사항이 있으면 스크롤
      $isMobile={isMobile}
    >
      {isEditMode && (hasChanged || imageChanged) && (
        <ChangedIconWrap>
          <ChangedIcon src={orangeIcon} alt="Unsaved changes" />
        </ChangedIconWrap>
      )}
      <MemberProfileAndInfo />
      {showDescriptionBlock && (
        <DescriptionWrapper $isMobile={isMobile}>
          <MoleculeTextareaDescription
            value={
              aboutContentMode === AboutContentMode.ENG
                ? memberInfo.descriptionEn ?? ''
                : memberInfo.description
            }
            handleChange={(e) =>
              handleChange(
                aboutContentMode === AboutContentMode.ENG
                  ? { descriptionEn: e.target.value }
                  : { description: e.target.value },
              )
            }
            StyledTextarea={NormalSmallTextArea}
            StyledDescription={Description}
            placeholder={getMemberDescriptionPlaceholder()}
            maxLength={MEMBER_DESCRIPTION_MAX_LENGTH}
            maxRows={100}
          />
        </DescriptionWrapper>
      )}
    </MemberInfoComp>
  );
};


const MemberInfoComp = styled.section<{ $isMobile: boolean }>`
  position: relative;
  width: ${({ $isMobile }) => $isMobile ? "100%" : "clamp(320px, 65vw, 600px)"};
  height: fit-content;
  display: flex;
  flex-direction: column;

  padding-bottom: clamp(15px, 3vh, 30px);
`;

const DescriptionWrapper = styled.div<{ $isMobile: boolean }>`
  width: 100%;
`;

const ChangedIconWrap = styled.div`
  position: absolute;
  top: 0;
  right: -4px;
  display: flex;
  align-items: center;
  ${imHere}
`;

const ChangedIcon = styled.img`
  width: 12px;
  height: 12px;
  margin: 4px;
`;

const Description = styled.div`
  padding: 30px 0px 0px 0px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  text-align: left;
  line-height: 1.6;
  ${({ theme }) => theme.typography.Body_04};
`;


export default MemberInfo;
